
export const GET_BORROW_REQUEST :string = "/BorrowRequest/GetReceivedBorrowRequests";
export const GET_SENT_BORROW_REQUEST :string = "/BorrowRequest/GetSentBorrowRequests";
export const REGISTER_BORROW_REQUEST_APPROVAL_BY_OWNER :string = "/BorrowRequest/BorrowRequestApprovalByOwner";
export const REGISTER_BORROW_REQUEST_APPROVAL_BY_BORROWER :string = "/BorrowRequest/BorrowRequestApprovalByBorrower";
export const SEND_APPROVAL_OTP :string = "/BorrowRequest/SendApprovalOTP";
